// extracted by mini-css-extract-plugin
export default {"root":"side-navigation-container_root__5gyDk","placeHolderShimmer":"side-navigation-container_placeHolderShimmer__Cz7XD"};